import React from "react";
import { MESSAGE_TYPE_LOCAL, MESSAGE_TYPE_REMOTE } from "..";
import { getFormatter } from "../../base/i18n";
import AbstractMessageContainer from "./AbstractMessageContainer";

import { ReciveFile } from "./ReciveFile";
import ReciveText from "./ReciveText";

export default class MessageContainer extends AbstractMessageContainer {
    constructor(props) {
        super(props);

        this._isScrolledToBottom = true;

        this._messageListRef = React.createRef();
        this._messagesListEndRef = React.createRef();

        this._onChatScroll = this._onChatScroll.bind(this);
    }

    maybeUpdateBottomScroll() {
        if (this._isScrolledToBottom) {
            this.scrollToBottom(false);
        }
    }

    scrollToBottom(withAnimation) {
        if (this._messagesListEndRef) {
            this._messagesListEndRef.current.scrollIntoView({
                behavior: 'auto',
                block: 'end'
            });
        }  
    }

    _onChatScroll() {
        const element = this._messagesListEndRef.current;

        this._isScrolledToBottom
            = element.scrollHeight - element.scrollTop === element.clientHeight;
    }

    render() {
        const { t } = this.props;

        return (
            <div className="chat_content" 
                ref={ this._messageListRef } 
                onScroll = { this._onChatScroll }
            >
                {
                    this.props.messages.map((value, index) => {
                        const {
                            isMe, 
                            displayName,
                            recipient,
                            messageType,
                            message,
                            timestamp
                        } = value;
                        
                        if (!value.error) {
                            const transferNum = recipient?.length || 0;
                            
                            let displayRecipientName = transferNum === 1 ? `${recipient[0]?.name}`
                                : transferNum > 1 ? `${recipient[0]?.name} ${t("chat.etc")} ${transferNum-1} ${t("chat.person")}` 
                                : t("chat.all");

                            const senderName = isMe ? t("chat.messageFrom", { recipient: displayRecipientName }) 
                                : t('chat.messageTo', { sender: displayName, recipient: displayRecipientName });

                            const isPrivate = transferNum === 0 ? false : true;
                            const time = getFormatter(timestamp);
                            return (
                                <div key={index}  className={`message message_${isPrivate} ${messageType} ${isMe ? MESSAGE_TYPE_LOCAL : MESSAGE_TYPE_REMOTE}`}>
                                    {messageType === "text" 
                                        ? <ReciveText t={t} message={message} recipient={senderName} time={time} />
                                        : <ReciveFile t={t} message={message} recipient={senderName} time={time} /> 
                                    }                                    
                                </div>
                            );
                        }
                        
                        return (
                            <p key={index} 
                                className="message_context" style={{
                                float: "right", color: "red", marginRight: "15px;"
                            }}> 
                                { t("chat.sendFail") }: {value.message} 
                            </p>
                        );
                    })
                }

                <div ref={ this._messagesListEndRef }/>
            </div>
        )
    }
}
